<template>
  <div class="hm-check" :class="{ checked: value }">
    <i v-if="value" class="far fa-check"> </i>
    <i v-else class="far fa-times"> </i>
  </div>
</template>

<script>
import Vue, { PropOptions } from 'vue';
import StyleType from '@/core/typings/enums/StyleType';

export default Vue.extend({
  name: 'HMCheck',
  props: {
    value: {
      type: Boolean,
      default: true,
      required: true,
    },
  },
});
</script>

<style lang="scss" scoped>
@import '@/web/styles/components-variables.scss';

.hm-check {
  border-radius: 50%;
  width: 26px;
  height: 26px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  background-color: lighten($light-gray, 4%);
  color: $medium-gray;
  &.checked {
    background-color: lighten($light-green, 25%);
    color: $light-green;
  }
}
</style>
